import { styled, keyframes } from "styled-components";

const rotate = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

export const WhatWeDoSectionStyled = styled.section`
  width: 100%;
  padding: 140px 20px;
  background: var(--bg-secondary);
  position: relative;
  overflow: hidden;

  /* Large decorative text */
  &::before {
    content: "WHAT WE DO";
    position: absolute;
    top: 60px;
    left: 50%;
    transform: translateX(-50%);
    font-family: Poppins;
    font-size: 180px;
    font-weight: 900;
    color: var(--text-primary);
    opacity: 0.03;
    white-space: nowrap;
    pointer-events: none;
    letter-spacing: -10px;
  }

  /* Rotating decoration */
  .rotatingBadge {
    position: absolute;
    top: 100px;
    right: 80px;
    width: 120px;
    height: 120px;
    animation: ${rotate} 20s linear infinite;

    svg {
      width: 100%;
      height: 100%;
    }

    text {
      fill: var(--primary);
      font-size: 10px;
      font-weight: 600;
      text-transform: uppercase;
      letter-spacing: 3px;
    }
  }

  .whatWeDoSectionContainer {
    max-width: 1400px;
    width: 100%;
    margin: 0 auto;
    position: relative;
    z-index: 1;
  }

  .sectionHeader {
    margin-bottom: 80px;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    gap: 40px;

    .headerLeft {
      max-width: 600px;

      .sectionLabel {
        display: inline-flex;
        align-items: center;
        gap: 12px;
        margin-bottom: 20px;

        .line {
          width: 40px;
          height: 3px;
          background: var(--accent);
          border-radius: 2px;
        }

        span {
          font-family: Poppins;
          font-size: 14px;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 3px;
          color: var(--accent);
        }
      }

      h2 {
        font-family: Poppins;
        font-size: 56px;
        font-weight: 800;
        line-height: 1.1;
        color: var(--text-primary);
        margin: 0;

        .outline {
          -webkit-text-stroke: 2px var(--text-primary);
          -webkit-text-fill-color: transparent;
        }
      }
    }

    .headerRight {
      max-width: 400px;

      p {
        font-family: Poppins;
        font-size: 18px;
        line-height: 1.7;
        color: var(--text-secondary);
      }
    }
  }

  .whatweDoWrapper {
    display: grid;
    grid-template-columns: 1fr 1.2fr;
    gap: 80px;
    align-items: center;

    .imageWrapper {
      position: relative;

      .imageFrame {
        position: relative;
        border-radius: 24px;
        overflow: hidden;

        &::before {
          content: "";
          position: absolute;
          inset: 0;
          border: 3px solid var(--accent);
          border-radius: 24px;
          transform: translate(20px, 20px);
          z-index: -1;
        }

        img {
          width: 100%;
          height: auto;
          display: block;
          border-radius: 24px;
          transition: transform 0.5s ease;
        }

        &:hover img {
          transform: scale(1.03);
        }
      }

      .statsBox {
        position: absolute;
        bottom: -30px;
        right: -30px;
        background: var(--accent);
        color: #fff;
        padding: 30px 40px;
        border-radius: 16px;
        box-shadow: 0 20px 50px rgba(217, 58, 53, 0.3);

        .number {
          font-family: Poppins;
          font-size: 48px;
          font-weight: 800;
          line-height: 1;
        }

        .label {
          font-family: Poppins;
          font-size: 14px;
          font-weight: 500;
          text-transform: uppercase;
          letter-spacing: 1px;
          opacity: 0.9;
        }
      }
    }

    .itemsWrapper {
      display: flex;
      flex-direction: column;
      gap: 24px;
    }
  }

  @media (max-width: 1024px) {
    padding: 100px 20px;

    &::before {
      font-size: 100px;
    }

    .rotatingBadge {
      display: none;
    }

    .sectionHeader {
      flex-direction: column;
      align-items: flex-start;
      margin-bottom: 60px;

      .headerLeft h2 {
        font-size: 42px;
      }
    }

    .whatweDoWrapper {
      grid-template-columns: 1fr;
      gap: 60px;

      .imageWrapper {
        order: -1;
        max-width: 500px;
        margin: 0 auto;

        .statsBox {
          right: 0;
          bottom: -20px;
        }
      }
    }
  }

  @media (max-width: 640px) {
    padding: 80px 20px;

    &::before {
      display: none;
    }

    .sectionHeader .headerLeft h2 {
      font-size: 32px;
    }

    .whatweDoWrapper .imageWrapper .statsBox {
      padding: 20px 30px;

      .number {
        font-size: 36px;
      }
    }
  }
`;
